<script>
  import { faArrowUp } from '@fortawesome/free-solid-svg-icons'
  import Icon from 'fa-svelte'
  import { fade } from 'svelte/transition'

  let arrowUp = false

  window.onscroll = function () {
    showArrowUp()
  }

  function showArrowUp () {
    if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
      arrowUp = true
    } else {
      arrowUp = false
    }
  }

  function arrowUpClick () {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    })
  }

</script>




{#if arrowUp}
  <div class="fixed bottom-0 right-0 mb-32 mr-10 w-12 h-12 rounded-full bg-red-500 text-white cursor-pointer select-none
              text-xl flex justify-center items-center z-30 arrow-up"
       transition:fade
       on:click={arrowUpClick}
  >
    <Icon icon={faArrowUp} />
  </div>
{/if}

<style>
    .arrow-up {

        /*right: 0;*/
        /*bottom: 6rem;*/
    }
</style>
